var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBoxSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.3674,
    y1: 0.33914,
    x2: 0.367401,
    y2: 13.3391,
    stroke: "#111111"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.1526,
    y1: 7.33914,
    x2: 6.36976,
    y2: 14.6872,
    stroke: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBoxSizeIcon);
export default __webpack_public_path__ + "static/media/TextBoxSizeIcon.004ebe7aeb77fe4d88c1fef0c76bc4fa.svg";
export { ForwardRef as ReactComponent };